module.exports = __webpack_public_path__ + "static/media/2DGACM8.03bc8902.jpg";